import NumbersIcon from "@mui/icons-material/NumbersRounded";
import { Avatar, Stack, Typography } from "@mui/material";
import { makeTintedBackgroundFromColor } from "@entrilia/shared/utilities/colorHelper";

const WorkflowChannelCardTitle = () => {
  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      <Avatar
        variant="rounded"
        sx={(t) => ({ width: 20, height: 20, bgcolor: makeTintedBackgroundFromColor(t, t.palette.info.main) })}
      >
        <NumbersIcon sx={{ width: 16, height: 16, color: "info.main" }} />
      </Avatar>
      <Typography variant="subtitle1">Channel</Typography>
    </Stack>
  );
};

export default WorkflowChannelCardTitle;
